import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import domtoimage from "dom-to-image";
import "../css/Reporte.css";
import ProgressBar from "./ProgressBar";
import ProgressBarTotal from "./ProgressBar_Total";
import provincia1 from "../images/mapa_elqui.png";
import provincia2 from "../images/mapa_limari.png";
import provincia3 from "../images/mapa_choapa.png";
import mapa1 from "../images/mapa_color_elqui.png";
import mapa2 from "../images/mapa_color_limari.png";
import mapa3 from "../images/mapa_color_choapa.png";
import Modal from "react-modal";
import logotipos from "../images/logotipos_uls.jpg";

function Reporte() {
  const [fecha, setFecha] = useState([]);
  const [elqui, setElqui] = useState([]);
  const [limari, setLimari] = useState([]);
  const [choapa, setChoapa] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isHorizontal, setIsHorizontal] = useState(false); // 👈 nuevo estado
  const modalContentRef = useRef(null);

  const handleOpenModal = () => {
    if (window.innerWidth >= 900) setIsOpen(true);
  };

  const handleResize = () => {
    if (window.innerWidth < 900 && isOpen) setIsOpen(false);
  };

  const handleCloseModal = () => setIsOpen(false);

  const fetchFechaReporte = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/fecha_reporte.php`,
    );
    setFecha(response.data);
  };
  const fetchElqui = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/reporte.php`,
    );
    setElqui(response.data);
  };
  const fetchLimari = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/reporte_2.php`,
    );
    setLimari(response.data);
  };
  const fetchChoapa = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/reporte_3.php`,
    );
    setChoapa(response.data);
  };

  const handleBodyScroll = (isOpen) => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  };

  useEffect(() => {
    handleBodyScroll(isOpen);
    fetchFechaReporte();
    fetchElqui();
    fetchLimari();
    fetchChoapa();
    window.addEventListener("resize", handleResize);
    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("resize", handleResize);
    };
  }, [isOpen]);

  const volumenActualElqui = elqui.reduce(
    (acc, c) => acc + parseFloat(c.actual),
    0,
  );
  const volumenActualLimari = limari.reduce(
    (acc, c) => acc + parseFloat(c.actual),
    0,
  );
  const volumenActualChoapa = choapa.reduce(
    (acc, c) => acc + parseFloat(c.actual),
    0,
  );
  const totalVolumenActual =
    volumenActualElqui + volumenActualLimari + volumenActualChoapa;

  const volumenTotalElqui = elqui.reduce(
    (acc, c) => acc + parseFloat(c.total),
    0,
  );
  const volumenTotalLimari = limari.reduce(
    (acc, c) => acc + parseFloat(c.total),
    0,
  );
  const volumenTotalChoapa = choapa.reduce(
    (acc, c) => acc + parseFloat(c.total),
    0,
  );
  const totalVolumenTotal =
    volumenTotalElqui + volumenTotalLimari + volumenTotalChoapa;

  const downloadImage = () => {
    if (!modalContentRef.current) return;
    const el = modalContentRef.current;
    const originalTransform = el.style.transform;

    el.style.transform = "scale(3)";
    el.style.transformOrigin = "top left";

    domtoimage
      .toPng(el, {
        filter: (node) =>
          !node.classList || !node.classList.contains("no-capture"),
        scale: 3,
        width: el.offsetWidth * 3,
        height: el.offsetHeight * 3,
      })
      .then((dataUrl) => {
        el.style.transform = originalTransform;
        const link = document.createElement("a");
        link.download = "Reporte_situación_hídrica_embalses.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        el.style.transform = originalTransform;
        console.error("Error generating image:", error);
      });
  };

  // Sub-componentes reutilizables para cada provincia
  const ProvinciaElqui = ({ imgClass, showLogotipos }) => (
    <div className="contenedorProvinciaModal">
      <h3 className="modalNombreProvincia">
        Provincia <strong>Elqui</strong>
      </h3>
      <h4>Total Acumulado</h4>
      <h3 className="modalTotalAcumulado">
        {(volumenActualElqui * 1000000).toLocaleString("es")}{" "}
        <span style={{ textTransform: "lowercase", fontFamily: "sans-serif" }}>
          m
        </span>
        <sup>3</sup>
      </h3>
      <div className="contenedorMapa">
        <img className={imgClass} src={mapa1} alt="Mapa Elqui" />
      </div>
      {elqui.map((item, index) => (
        <div key={index}>
          <h2>{item.embalse}</h2>
          <label className="volumenActualModal">
            Volumen Actual: {parseFloat(item.actual).toLocaleString("es")} Hm
            <sup>3</sup>
          </label>
          <ProgressBarTotal
            completed={((item.actual / item.total) * 100).toFixed(1)}
          />
          <div className="volumenTotalContainer">
            <label className="volumenTotal">
              Volumen Total: {parseFloat(item.total).toLocaleString("es")} Hm
              <sup>3</sup>
            </label>
          </div>
        </div>
      ))}
      {showLogotipos && (
        <div className="contenedorLogotipos">
          <img src={logotipos} alt="Logotipos ULS" />
          <p>
            Información entregada por las organizaciones administradoras de los
            embalses, y la Dirección General de Aguas de la Región de Coquimbo.
          </p>
        </div>
      )}
    </div>
  );

  const ProvinciaLimari = ({ imgClass }) => (
    <div className="contenedorProvinciaModal">
      <h3 className="modalNombreProvincia_limari">
        Provincia <strong>Limarí</strong>
      </h3>
      <h4>Total Acumulado</h4>
      <h3 className="modalTotalAcumulado_limari">
        {(volumenActualLimari * 1000000).toLocaleString("es")}{" "}
        <span style={{ textTransform: "lowercase", fontFamily: "sans-serif" }}>
          m
        </span>
        <sup>3</sup>
      </h3>
      <div className="contenedorMapa">
        <img className={imgClass} src={mapa2} alt="Mapa Limarí" />
      </div>
      {limari.map((item, index) => (
        <div key={index}>
          <h2>{item.embalse}</h2>
          <label className="volumenActualModal">
            Volumen Actual: {parseFloat(item.actual).toLocaleString("es")} Hm
            <sup>3</sup>
          </label>
          <ProgressBarTotal
            completed={((item.actual / item.total) * 100).toFixed(1)}
          />
          <div className="volumenTotalContainer">
            <label className="volumenTotal">
              Volumen Total: {parseFloat(item.total).toLocaleString("es")} Hm
              <sup>3</sup>
            </label>
          </div>
        </div>
      ))}
    </div>
  );

  const ProvinciaChoapa = ({ imgClass, showLogotipos }) => (
    <div className="contenedorProvinciaModal">
      <h3 className="modalNombreProvincia">
        Provincia <strong>Choapa</strong>
      </h3>
      <h4>Total Acumulado</h4>
      <h3 className="modalTotalAcumulado">
        {(volumenActualChoapa * 1000000).toLocaleString("es")}{" "}
        <span style={{ textTransform: "lowercase", fontFamily: "sans-serif" }}>
          m
        </span>
        <sup>3</sup>
      </h3>
      <div className="contenedorMapa">
        <img className={imgClass} src={mapa3} alt="Mapa Choapa" />
      </div>
      {choapa.map((item, index) => (
        <div key={index}>
          <h2>{item.embalse}</h2>
          <label className="volumenActualModal">
            Volumen Actual: {parseFloat(item.actual).toLocaleString("es")} Hm
            <sup>3</sup>
          </label>
          <ProgressBarTotal
            completed={((item.actual / item.total) * 100).toFixed(1)}
          />
          <div className="volumenTotalContainer">
            <label className="volumenTotal">
              Volumen Total: {parseFloat(item.total).toLocaleString("es")} Hm
              <sup>3</sup>
            </label>
          </div>
        </div>
      ))}
      {showLogotipos && (
        <div
          className={
            isHorizontal
              ? "contenedorLogotiposHorizontal"
              : "contenedorLogotipos"
          }
        >
          <img src={logotipos} alt="Logotipos ULS" />
          <p>
            Información entregada por las organizaciones administradoras de los
            embalses, y la Dirección General de Aguas de la Región de Coquimbo.
          </p>
        </div>
      )}
    </div>
  );

  // Versión VERTICAL del modal (original)
  const ModalVertical = () => (
    <div className="contenedorFondoImagen">
      <div className="fondoImagenModal">
        <div className="modalReporte">
          <h1>Reporte situación hídrica embalses</h1>
          {fecha.map((f, index) => (
            <div className="contenedorFechaReporte" key={index}>
              <h2>región de coquimbo</h2>
              <h2>{f.fecha}</h2>
            </div>
          ))}
          <div className="modalReporteTotal">
            <p>Total Volumen Regional</p>
            <label>
              Volumen Actual: {totalVolumenActual.toLocaleString("es")} Hm
              <sup>3</sup>
            </label>
            <ProgressBarTotal
              completed={(
                (totalVolumenActual / totalVolumenTotal) *
                100
              ).toFixed(1)}
            />
            <label>
              Volumen Total: {totalVolumenTotal.toLocaleString("es")} Hm
              <sup>3</sup>
            </label>
          </div>
          <h3>Estado de las Cuencas</h3>
          <div className="modalProvincias">
            <ProvinciaElqui imgClass="mapaColor" showLogotipos={true} />
            <ProvinciaLimari imgClass="mapaColor" />
            <ProvinciaChoapa imgClass="mapaColor" showLogotipos={false} />
          </div>
        </div>
        <div className="modalButtons no-capture">
          <button onClick={handleCloseModal}>Cerrar</button>
          <button onClick={() => setIsHorizontal((prev) => !prev)}>
            Rotar Orientación Reporte
          </button>
          <button onClick={downloadImage}>Descargar</button>
        </div>
      </div>
    </div>
  );

  // Versión HORIZONTAL del modal
  const ModalHorizontal = () => (
    <div className="contenedorFondoImagenHorizontal">
      <div className="fondoImagenModal">
        <div className="modalReporte">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <h1>Reporte situación hídrica embalses</h1>
              {fecha.map((f, index) => (
                <div className="contenedorFechaReporte" key={index}>
                  <h2>región de coquimbo&nbsp;</h2>
                  <h2>{f.fecha}</h2>
                </div>
              ))}
            </div>
            <div className="modalReporteTotalHorizontal">
              <p>Total Volumen Regional</p>
              <label>
                Volumen Actual: {totalVolumenActual.toLocaleString("es")} Hm
                <sup>3</sup>
              </label>
              <ProgressBarTotal
                completed={(
                  (totalVolumenActual / totalVolumenTotal) *
                  100
                ).toFixed(1)}
              />
              <label>
                Volumen Total: {totalVolumenTotal.toLocaleString("es")} Hm
                <sup>3</sup>
              </label>
            </div>
          </div>
          <h3>Estado de las Cuencas</h3>
          <div className="modalProvincias">
            <ProvinciaElqui
              imgClass="mapaColorHorizontal"
              showLogotipos={false}
            />
            <ProvinciaLimari imgClass="mapaColorHorizontal" />
            <ProvinciaChoapa
              imgClass="mapaColorHorizontal"
              showLogotipos={true}
            />
          </div>
        </div>
        <div className="modalButtons no-capture">
          <button onClick={handleCloseModal}>Cerrar</button>
          <button onClick={() => setIsHorizontal((prev) => !prev)}>
            Rotar Orientación Reporte
          </button>
          <button onClick={downloadImage}>Descargar</button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <div className="reporte">
        <h1>Reporte Situación hídrica embalses</h1>
        {fecha.map((f, index) => (
          <div key={index}>
            <h2>{f.fecha}</h2>
          </div>
        ))}
        <div className="reporteTotal">
          <h3 className="totalRegional">Total Volumen Regional</h3>
          <label className="volumenActualTotal">
            Volumen Actual: {totalVolumenActual.toLocaleString("es")} Hm
            <sup>3</sup>
          </label>
          <ProgressBarTotal
            completed={((totalVolumenActual / totalVolumenTotal) * 100)
              .toFixed(1)
              .toLocaleString("es")}
          />
          <div className="volumenTotalContainer">
            <label className="volumenTotal">
              Volumen Total: {totalVolumenTotal.toLocaleString("es")} Hm
              <sup>3</sup>
            </label>
          </div>
        </div>
        <div className="reporteElqui" onClick={handleOpenModal}>
          <h3>Provincia de Elqui</h3>
          <img src={provincia1} alt="Provincia Elqui" />
          {elqui.map((item, index) => (
            <div key={index}>
              <h4>{item.embalse}</h4>
              <label className="volumenActual">
                Volumen Actual: {parseFloat(item.actual).toLocaleString("es")}{" "}
                Hm<sup>3</sup>
              </label>
              <ProgressBar
                completed={((item.actual / item.total) * 100).toFixed(1)}
              />
              <div className="volumenTotalContainer">
                <label className="volumenTotal">
                  Volumen Total: {parseFloat(item.total).toLocaleString("es")}{" "}
                  Hm<sup>3</sup>
                </label>
              </div>
            </div>
          ))}
          <label className="estadoCuenca">
            Estado de Cuenca:{" "}
            {(volumenActualElqui * 1000000).toLocaleString("es")} m<sup>3</sup>
          </label>
        </div>
        <div className="reporteLimari" onClick={handleOpenModal}>
          <h3>Provincia de Limari</h3>
          <img src={provincia2} alt="Provincia Limarí" />
          {limari.map((item, index) => (
            <div key={index}>
              <h4>{item.embalse}</h4>
              <label className="volumenActual">
                Volumen Actual: {parseFloat(item.actual).toLocaleString("es")}{" "}
                Hm<sup>3</sup>
              </label>
              <ProgressBar
                completed={((item.actual / item.total) * 100).toFixed(1)}
              />
              <div className="volumenTotalContainer">
                <label className="volumenTotal">
                  Volumen Total: {parseFloat(item.total).toLocaleString("es")}{" "}
                  Hm<sup>3</sup>
                </label>
              </div>
            </div>
          ))}
          <label className="estadoCuenca">
            Estado de Cuenca:{" "}
            {(volumenActualLimari * 1000000).toLocaleString("es")} m<sup>3</sup>
          </label>
        </div>
        <div className="reporteChoapa" onClick={handleOpenModal}>
          <h3>Provincia de Choapa</h3>
          <img src={provincia3} alt="Provincia Choapa" />
          {choapa.map((item, index) => (
            <div key={index}>
              <h4>{item.embalse}</h4>
              <label className="volumenActual">
                Volumen Actual: {parseFloat(item.actual).toLocaleString("es")}{" "}
                Hm<sup>3</sup>
              </label>
              <ProgressBar
                completed={((item.actual / item.total) * 100).toFixed(1)}
              />
              <div className="volumenTotalContainer">
                <label className="volumenTotal">
                  Volumen Total: {parseFloat(item.total).toLocaleString("es")}{" "}
                  Hm<sup>3</sup>
                </label>
              </div>
            </div>
          ))}
          <label className="estadoCuenca">
            Estado de Cuenca:{" "}
            {(volumenActualChoapa * 1000000).toLocaleString("es")} m<sup>3</sup>
          </label>
        </div>
      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={true}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          content: {
            backgroundColor: "transparent",
            padding: "0px",
            borderRadius: "10px",
            width: "100%",
            height: "95%",
            margin: "auto",
            inset: "0px",
            border: "none",
            overflowY: "auto",
          },
        }}
      >
        <div ref={modalContentRef}>
          {isHorizontal ? <ModalHorizontal /> : <ModalVertical />}
        </div>
      </Modal>
    </div>
  );
}

export default Reporte;
